
import { createSelector } from 'reselect';

import { concatMap } from '../../../methods';

const getActiveVerticalId = ({ activeVerticalId }) => activeVerticalId;

const getVerticals = ({ verticals }) => verticals;

const getRoomResults = searchResults => searchResults.data;

const getRoomById = (state, roomId) =>
    state.searchResults.data.find(room => room.id === roomId);

const findFilterGroup = (
    state,
    filterGroupCollectionIndex,
    filterGroupIndex
) => {
    return state.verticals.find(vertical =>
        vertical.id === state.activeVerticalId
    ).filterGroupCollections[filterGroupCollectionIndex]
        .filterGroups[filterGroupIndex];
};

const getFilterGroupExpansionStatus = (
    state,
    filterGroupCollectionIndex,
    filterGroupIndex
) => {
    return state.verticals.find(vertical =>
        vertical.id === state.activeVerticalId
    ).filterGroupCollections[filterGroupCollectionIndex]
        .filterGroups[filterGroupIndex].isExpanded;
};

const getActiveFilterGroupCollection = state => {
    return state.verticals.find(vert =>
        vert.id === state.activeVerticalId
    ).filterGroupCollections[state.activeFilterGroupCollectionIndex];
};

// const getFilterGroupCollection = (state, filterGroupCollectionIndex) => {
//     return state.verticals.find(vert =>
//         vert.id === state.activeVerticalId
//     ).filterGroupCollections.find((fGC, index) => index === filterGroupCollectionIndex);
// };

const getSliderValues = (state, filterGroupCollectionIndex) => {
    return state.verticals.find(vert =>
        vert.id === state.activeVerticalId
    ).filterGroupCollections.find((fGC, index) =>
        index === filterGroupCollectionIndex
    ).filters[0].data.values;
};

const getTagLabel = state => {
    return state.tags.tags.find(tag => tag.quick_slug === state.searchParams.tag).label;
};

export const getActiveFilterCount = createSelector(
    [ getActiveVerticalId, getVerticals ],
    (activeVerticalId, verticals) => {
        return concatMap(
            concatMap(verticals.find(
                vertical => vertical.id === activeVerticalId
            ).filterGroupCollections, filterGroupCollection =>
                filterGroupCollection.filterGroups.filter(filterGroup => {
                    if (filterGroup) {
                        return filterGroup.inputType === 'checkbox' ||
                        filterGroup.inputType === 'toggle-switch' ||
                        filterGroup.inputType === 'radio' ||
                        filterGroup.inputType === 'increment' ||
                        filterGroup.inputType === 'slider' ||
                        filterGroup.inputType === 'dropdown';
                    }
                }
                )
            ),
            filterGroup =>
                filterGroup.filters
        )
            .filter(filter => {
                if (filter.data.type === 'range') {
                    const array = [];
                    filter.data.values.map(value => {
                        filter.data.defaults.map(def => {
                            if (def.slug === value.slug && def.value !== value.value) {
                                array.push(value.value);
                            }
                        });
                    });
                    return array.length;
                }
                return filter.data.value !== filter.data.default;
            }).length;
    }
);

export const getCardsLength = createSelector(
    [ getRoomResults ],
    cards => cards.length
);

export const getCardByKey = createSelector(
    [ getRoomById ],
    room => room
);

export const getMapMarkers = createSelector(
    [ getRoomResults ],
    rooms => rooms.map(result => ({
        id: result.id,
        currency: result.currency,
        position: {
            lat: Number(result.lat),
            lng: Number(result.long)
        },
        price: ((result.listing_hourly_rate !== null && result.listing_hourly_rate !== 0) ? result.listing_hourly_rate :
            ((result.daily_rate !== null && result.daily_rate !== 0) ? result.daily_rate :
                ((result.monthly_rate !== null && result.monthly_rate !== 0) ? result.monthly_rate : 0)))
    }))
);

export const getFilterGroup = createSelector(
    [ findFilterGroup ],
    filterGroup => filterGroup
);

export const getFilters = createSelector(
    [ findFilterGroup ],
    filterGroup => filterGroup.filters
);

export const isFilterGroupExpanded = createSelector(
    [ getFilterGroupExpansionStatus ],
    isExpanded => isExpanded
);

export const getActiveFilterGroupCollectionPanelType = createSelector(
    [ getActiveFilterGroupCollection ],
    activeFilterGroupCollection => {
        if (activeFilterGroupCollection) {
            return activeFilterGroupCollection.panelType;
        }
        return '';
    }
);

export const getAverageResultPrice = createSelector(
    [ getRoomResults ],
    roomResults => {
        let total = 0;
        roomResults.map(result => {
            if (result.listing_hourly_rate) {
                total += Number(result.listing_hourly_rate);
            }
        });
        return total / roomResults.length;
    }
);

export const getSliderButtonText = createSelector(
    [ getSliderValues ],
    sliderValues => {
        // console.log(sliderValues);
        // return `£${sliderValues}`;
    }
);

export const isAllDaySelected = createSelector(
    [ getActiveFilterGroupCollection ],
    activeFilterGroupCollection => {
        if (activeFilterGroupCollection) {
            return Boolean(activeFilterGroupCollection.filterGroups.filter(fGroup => {
                if (fGroup.slug === 'all-day') {
                    return fGroup.filters.find(filter => filter.data.value);
                }
            }).length);
        }
        return false;
    }
);

export const tagLabel = createSelector(
    [ getTagLabel ],
    label => label
);



// WEBPACK FOOTER //
// ./src/pages/Search/selectors/index.js